import * as React from "react";
import { Brand } from "@payright/web-components";
import moment from "moment";
import { SCLoanDetailDashboard } from "./css";
import genericlogo from "./generic_logo1.png";

export interface LoanDetailDashboardProps {
  /** loan dashboard data */
  loanDashBoardData: {
    loanName: string;
    storeName: string;
    paymentFrequency: number;
    paidAmount: number;
    loanStatus: string;
    balanceRemaining: number;
    nextRepaymentDate: string;
    nextRepaymentAmount: number;
  };
}

const LoanDetailDashboard = ({
  loanDashBoardData
}: LoanDetailDashboardProps) => (
  <SCLoanDetailDashboard>
    <div className="loan-container">
      <div className="left-col">
        <Brand
          reference={loanDashBoardData.storeName}
          icon={genericlogo}
          name={loanDashBoardData.loanName}
        />
      </div>
      <div className="right-col">
        <div className="paid">
          <h6>Paid</h6>
          <h5>${loanDashBoardData.paidAmount}</h5>
        </div>
        <div className="slash">
          <h5>/</h5>
        </div>
        <div className="remaining">
          <h6>Remaining</h6>
          <h5>${loanDashBoardData.balanceRemaining}</h5>
        </div>
        <div className="nextPaymentAmt">
          <h6>Next Repayment Amount</h6>
          <h5>${loanDashBoardData.nextRepaymentAmount}</h5>
        </div>
        <div className="nextPaymentDate">
          <h6>Next Repayment Date</h6>
          <h5>{loanDashBoardData.nextRepaymentDate ? moment(loanDashBoardData.nextRepaymentDate).format("DD MMM YYYY"): 'N/A'}</h5>
        </div>
      </div>
    </div>
  </SCLoanDetailDashboard>
);

export default LoanDetailDashboard;
